import MATERIAL_TYPES from '../../../__core/Enums/MaterialTypes';

export const getTypeFilterArray = (
  filters: Record<string, unknown>
): Array<string> => {
  const type: Array<string> = [];

  for (const [key, value] of Object.entries(filters)) {
    if (value) {
      switch (key) {
        case 'presentations':
          type.push(MATERIAL_TYPES.PRESENTATION_PDF);
          type.push(MATERIAL_TYPES.PRESENTATION_REVEAL);
          break;

        case 'articles':
          type.push(MATERIAL_TYPES.ARTICLE);
          break;

        case 'attachments':
          type.push(MATERIAL_TYPES.ATTACHMENT);
          break;

        case 'exercises':
          type.push(MATERIAL_TYPES.EXERCISE);
          break;

        case 'snippets':
          type.push(MATERIAL_TYPES.SNIPPET);
          break;

        case 'quizzes':
          type.push(MATERIAL_TYPES.QUIZ);
          break;
      }
    }
  }

  return type;
};
